import {
  PersonSingle,
  VisibilityOff,
  StarEmpty,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

// WIP: the Search Page v2 designer filter is still under construction. This list is a
// temporary mock — there is no designer-search backend yet, so selecting a designer does
// not change results. Replace MOCK_DESIGNERS with the real list once the backend exists
// (it will filter by username/id); each entry keeps both so switching the value is trivial.
export const MOCK_DESIGNERS = [
  { id: 1, username: 'alex3d', name: 'Alex3D', modelsCount: 138, ratingPercent: 90, isFollowing: false },
  { id: 2, username: 'admyone', name: 'AdmyOne', modelsCount: 69, ratingPercent: 65, isFollowing: true },
  { id: 3, username: 'aston3d', name: 'Aston3D', modelsCount: 70, ratingPercent: 60, isFollowing: false },
  { id: 4, username: 'blendmaster', name: 'BlendMaster', modelsCount: 212, ratingPercent: 88, isFollowing: false },
  { id: 5, username: 'voxelia', name: 'Voxelia', modelsCount: 45, ratingPercent: 73, isFollowing: true },
  { id: 6, username: 'polycraft', name: 'PolyCraft', modelsCount: 312, ratingPercent: 95, isFollowing: false },
]

// Scope chips are visual-only for now: following/hidden/top need user-specific data that
// the backend will expose later, so toggling them does not filter the list yet.
export const DESIGNER_SCOPES = [
  { key: 'following', icon: PersonSingle },
  { key: 'hidden', icon: VisibilityOff },
  { key: 'top', icon: StarEmpty },
]
